import React from 'react';
import { NextSeo } from 'next-seo';
import RegistrationView from 'components/views/Registration';
import { NextPageWithLayout } from 'types/page';
import { getRegistrationLayout } from 'components/containers/RegistrationLayout';
import AuthPageProtection from 'components/containers/AuthProtection';

/**
 * Registration:
 * @return {NextPageWithLayout}
 */
const Registration: NextPageWithLayout = () => {
  return (
    <>
      <NextSeo title="Apply to Trend" />
      <AuthPageProtection>
        <RegistrationView />
      </AuthPageProtection>
    </>
  );
};

Registration.getLayout = getRegistrationLayout;

export default Registration;
